

const Shimmer = () => {

    return(
        <div className="shimmer">add shimmer here</div>
    )
}

export default Shimmer;